import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import Button from '@components/atoms/button/button';
import Icon from '@components/atoms/icon/icon';
import useWindowSize from '@hooks/use-window-size';
import styles from './chat-not-found.module.scss';

interface ChatNotFoundProps {
  hasError: boolean;
  closeHandler?: () => void;
}

const ChatNotFound: React.FC<ChatNotFoundProps> = ({ hasError, closeHandler }) => {
  const { t } = useTranslation();
  const { t: tA11y } = useTranslation('a11y');
  const { isWiderThanMd } = useWindowSize();

  return (
    <div className={clsx(styles.chatNotFound)}>
      {closeHandler && hasError && !isWiderThanMd && (
        <Button
          disableDefaultStyling
          className={styles.chatNotFound__closeButton}
          onClick={closeHandler}
          data-cy="chat-header-close-button"
        >
          <Icon
            className={styles.chatNotFound__closeButtonIcon}
            name={'cross-x'}
            ariaLabel={tA11y('A11Y.ICON.ARROW_PREVIOUS')}
          />
        </Button>
      )}
      <h1 className="vc-heading-A48">
        {hasError ? t('CHAT.DISCUSSIONS.ERROR_TITLE') : t('CHAT.DISCUSSIONS.NO_MESSAGES_TITLE')}
      </h1>
      <p className="vc-heading-A24">
        {hasError ? t('CHAT.DISCUSSIONS.ERROR_SUBTITLE') : t('CHAT.DISCUSSIONS.NO_MESSAGES_SUBTITLE')}
      </p>
    </div>
  );
};

export default ChatNotFound;
